import { useSearchParams } from "react-router-dom";
import StandardContactForm from "@/components/StandardContactForm";
import { WHATSAPP_URL, SALES_EMAIL, PHONE } from "@/constants/testIds";
import { MessageCircle, Mail, Phone } from "lucide-react";

export default function Contact() {
  const [params] = useSearchParams();
  const intent = params.get("intent");
  const brochure = intent === "brochure";

  const source = brochure ? "brochure_download" : "contact_page";
  const cta = brochure ? "Send me the brochure" : "Book my site visit";

  return (
    <div>
      <section className="pt-32 pb-8 bg-offwhite">
        <div className="container-editorial px-5 md:px-10 grid md:grid-cols-12 gap-10">
          <aside className="md:col-span-5">
            <div className="eyebrow text-teal mb-4">
              <span className="editorial-rule" /> {brochure ? "The Brochure" : "Book a Visit"}
            </div>
            <h1 className="font-display text-forest text-5xl md:text-6xl leading-[0.98]">
              {brochure ? "The plot map,\nthe paperwork,\nthe hill." : "Come see\nthe hill\nat golden hour."}
            </h1>
            <p className="mt-6 text-forest/70 leading-relaxed max-w-md">
              {brochure
                ? "Share a line about yourself and we'll email the Chapter III brochure. No automated follow-up you didn't consent to."
                : "We schedule Saturday and Sunday golden-hour visits at the Pali Hill City ridge. Two hours from Mumbai. Two hours from Pune. A different pace, entirely."}
            </p>

            <div className="mt-10 space-y-4 border-t border-forest/15 pt-8">
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-forest/85 hover:text-forest text-sm">
                <MessageCircle size={18} className="text-teal" />
                WhatsApp us — {PHONE}
              </a>
              <a href={`mailto:${SALES_EMAIL}`} className="flex items-center gap-3 text-forest/85 hover:text-forest text-sm">
                <Mail size={18} className="text-teal" />
                {SALES_EMAIL}
              </a>
              <a href={`tel:${PHONE}`} className="flex items-center gap-3 text-forest/85 hover:text-forest text-sm">
                <Phone size={18} className="text-teal" />
                {PHONE}
              </a>
            </div>
          </aside>
          <div className="md:col-span-6 md:col-start-7 bg-white rounded-lg p-6 md:p-8 border border-forest/10">
            <StandardContactForm source={source} ctaLabel={cta} />
          </div>
        </div>
      </section>

      <section className="section-pad bg-forest text-cream text-center">
        <div className="container-editorial max-w-2xl">
          <h2 className="font-display text-3xl md:text-4xl leading-tight">
            We would rather you take a slow walk on the ridge than skim a brochure.
          </h2>
          <p className="mt-6 text-cream/70 max-w-xl mx-auto">
            All contact is human. No automated calling loops, no third-party
            resale of contact details. That is on paper.
          </p>
        </div>
      </section>
    </div>
  );
}
